import { defineMessages } from 'react-intl';

export const scope = 'app.components.exams.workflow_table';

export default defineMessages({
  exam_title_aria: {
    id: `${scope}.exam_title_aria`,
    defaultMessage: 'exam-title',
  },
  view: {
    id: `${scope}.view`,
    defaultMessage: 'View',
  },
  not_available: {
    id: `${scope}.not_available`,
    defaultMessage: 'NA',
  },
});
